import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

import styles from './PlaceholderPage.module.css';

export default function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (!isNotFound) {
      Sentry.captureException(error);
    }
  }, [error, isNotFound]);

  return (
    <main className={styles.page}>
      <header className={styles.hero}>
        <h1 className={styles.title}>{isNotFound ? t('notFound.title') : t('error.title')}</h1>
        <p className={styles.tagline}>{isNotFound ? t('notFound.body') : t('error.body')}</p>
        <p className={styles.tagline}>
          <Link to="/">{t('backToBase')}</Link>
        </p>
      </header>
    </main>
  );
}
